/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RequestShipmentPackage } from './RequestShipmentPackage';
import {
    RequestShipmentPackageFromJSON,
    RequestShipmentPackageFromJSONTyped,
    RequestShipmentPackageToJSON,
    RequestShipmentPackageToJSONTyped,
} from './RequestShipmentPackage';
import type { RequestAmazonItem } from './RequestAmazonItem';
import {
    RequestAmazonItemFromJSON,
    RequestAmazonItemFromJSONTyped,
    RequestAmazonItemToJSON,
    RequestAmazonItemToJSONTyped,
} from './RequestAmazonItem';

/**
 * 
 * @export
 * @interface RequestUpdatePlanRequest
 */
export interface RequestUpdatePlanRequest {
    /**
     * 
     * @type {Array<RequestAmazonItem>}
     * @memberof RequestUpdatePlanRequest
     */
    amazonItems: Array<RequestAmazonItem>;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdatePlanRequest
     */
    baseId: number;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdatePlanRequest
     */
    endDate: string;
    /**
     * 
     * @type {boolean}
     * @memberof RequestUpdatePlanRequest
     */
    isShipping: boolean;
    /**
     * 
     * @type {Array<RequestShipmentPackage>}
     * @memberof RequestUpdatePlanRequest
     */
    packages: Array<RequestShipmentPackage>;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdatePlanRequest
     */
    planId: number;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdatePlanRequest
     */
    readyToShipDate: string;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdatePlanRequest
     */
    startDate: string;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdatePlanRequest
     */
    tenantId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdatePlanRequest
     */
    transportationOptionId?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdatePlanRequest
     */
    userId: number;
}

/**
 * Check if a given object implements the RequestUpdatePlanRequest interface.
 */
export function instanceOfRequestUpdatePlanRequest(value: object): value is RequestUpdatePlanRequest {
    if (!('amazonItems' in value) || value['amazonItems'] === undefined) return false;
    if (!('baseId' in value) || value['baseId'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('isShipping' in value) || value['isShipping'] === undefined) return false;
    if (!('packages' in value) || value['packages'] === undefined) return false;
    if (!('planId' in value) || value['planId'] === undefined) return false;
    if (!('readyToShipDate' in value) || value['readyToShipDate'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function RequestUpdatePlanRequestFromJSON(json: any): RequestUpdatePlanRequest {
    return RequestUpdatePlanRequestFromJSONTyped(json, false);
}

export function RequestUpdatePlanRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestUpdatePlanRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'amazonItems': ((json['amazon_items'] as Array<any>).map(RequestAmazonItemFromJSON)),
        'baseId': json['base_id'],
        'endDate': json['end_date'],
        'isShipping': json['is_shipping'],
        'packages': ((json['packages'] as Array<any>).map(RequestShipmentPackageFromJSON)),
        'planId': json['plan_id'],
        'readyToShipDate': json['ready_to_ship_date'],
        'startDate': json['start_date'],
        'tenantId': json['tenant_id'],
        'transportationOptionId': json['transportation_option_id'] == null ? undefined : json['transportation_option_id'],
        'userId': json['user_id'],
    };
}

export function RequestUpdatePlanRequestToJSON(json: any): RequestUpdatePlanRequest {
    return RequestUpdatePlanRequestToJSONTyped(json, false);
}

export function RequestUpdatePlanRequestToJSONTyped(value?: RequestUpdatePlanRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amazon_items': ((value['amazonItems'] as Array<any>).map(RequestAmazonItemToJSON)),
        'base_id': value['baseId'],
        'end_date': value['endDate'],
        'is_shipping': value['isShipping'],
        'packages': ((value['packages'] as Array<any>).map(RequestShipmentPackageToJSON)),
        'plan_id': value['planId'],
        'ready_to_ship_date': value['readyToShipDate'],
        'start_date': value['startDate'],
        'tenant_id': value['tenantId'],
        'transportation_option_id': value['transportationOptionId'],
        'user_id': value['userId'],
    };
}

